// Réglages du mouvement : les durées, les courbes et les seuils communs, en un seul endroit. Tout
// ce qui bouge sur le site les prend ici ; un geste (gestes.ts) n'écrit que son propre rythme.

/** Durées, en secondes. */
export const DUREE = {
  /** Changement d'état ordinaire, et toute apparition en mouvement réduit. */
  etat: 0.3,
  /** Un filet qui se trace. */
  pose: 0.7,
  /** Une apparition : un titre, un bloc. */
  entree: 0.9,
} as const;

/** Courbes GSAP. Décélération franche à l'arrivée, jamais de rebond. */
export const COURBE = {
  /** Arrivée : vite, puis se pose. */
  arrivee: 'expo.out',
  /** Compteurs. */
  douce: 'power2.out',
} as const;

/** Écart entre deux éléments d'une liste, et plafond du décalage total d'une liste. */
export const ECHELON = 0.07;
export const ECHELON_MAX = 0.45;

/**
 * Une apparition se joue quand le haut de l'élément franchit 85 % de l'écran. clamp() ramène le
 * seuil dans la page : un élément tout en bas (la rangée du contact) apparaît quand même.
 */
export const SEUIL = 'clamp(top 85%)';

/** Déplacement d'une apparition (pixels), et départ d'une ligne de titre sous son masque (%). */
export const MONTEE = 24;
export const LIGNE_SOUS = 140;

/** Empilement : la section recouverte recule jusqu'à cette échelle pendant que la suivante glisse. */
export const RECUL = 0.94;
